import { render, staticRenderFns } from "./previewDirectorio.vue?vue&type=template&id=2afdf39e&scoped=true"
import script from "./previewDirectorio.vue?vue&type=script&lang=js"
export * from "./previewDirectorio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afdf39e",
  null
  
)

export default component.exports